import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import placeholderCategory from '@/public/placeholder-category.svg'; // <-- import placeholder
import WhiteCard from '@/components/ui/WhiteCard';

interface CategoryItem {
  title: string;
  id?: string;
  // eventuali altri campi
  [key: string]: any;
  children?: CategoryItem[]; // <-- supporto figli
  image?: any; // <-- supporto immagine (string o oggetto)
}

interface CategoryListProps {
  whiteCardList: CategoryItem[];
  columns?: number; // default 4
  cardSx?: any;
  titleSx?: any;
  // opzionale: funzione chiamata quando si clicca una card
  onCardClick?: (id?: string, item?: CategoryItem) => void;
  // se presenti url in item usare come link (fallback semplice)
  useUrlIfExists?: boolean;
}

const CategoryList: React.FC<CategoryListProps> = ({ whiteCardList, columns = 4, onCardClick }) => {
  if (!whiteCardList || whiteCardList.length === 0) return <Box />;

  // calcolo span per breakpoint sm (es. columns=4 => sm=3)
  const smSpan = Math.max(1, Math.floor(12 / columns));

  const handleClick = (item: CategoryItem) => {
    if (onCardClick) {
      onCardClick(item.id, item); // passo anche l'item così il caller può decidere se ha figli o se è back
      return;
    }
  }

  return (
    <Box sx={{ position: 'relative', py: '20px' }}>
      <Container disableGutters sx={{ px: { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 } }}>
        <Grid container rowSpacing={2} columnSpacing={2}>
          {whiteCardList.map((item, idx) => {
            // costruisco img compatibile con WhiteCard (fallback al placeholder)
            const imageSrc = typeof item.image === 'string' ? item.image : (item.image?.mediaItemUrl || placeholderCategory);
            const img = {
              id: `category-card-image-${idx}`,
              mimeType: typeof imageSrc === 'string' && imageSrc.endsWith('.svg') ? 'image/svg+xml' : 'image/jpeg',
              mediaItemUrl: imageSrc,
              mediaDetails: { width: 255, height: 255 }
            };

            return (
              <Grid key={idx} item xs={6} sm={smSpan} sx={{ marginBottom: "35px" }}>
                <Box onClick={() => handleClick(item)} sx={{ cursor: onCardClick ? 'pointer' : undefined }}>
                  <WhiteCard title={item.title} img={img} placeholderImage={placeholderCategory} url={""} />
                </Box>
              </Grid>
            );
           })}
        </Grid>
      </Container>
    </Box>
  );
}

export default CategoryList;
